import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Send as SendIcon,
} from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import * as React from 'react';

interface NavigationButtonsProps {
  canGoBack: boolean;
  canGoNext: boolean;
  canProceed: boolean;
  isLastQuestion: boolean;
  isFormValid: boolean;
  // isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
  submitButtonText: string;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  canGoBack,
  canGoNext,
  canProceed,
  isLastQuestion,
  isFormValid,
  // isSubmitting,
  onBack,
  onNext,
  onSubmit,
  submitButtonText,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 3,
        mt: 4,
        pb: 10,
      }}
    >
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={!canGoBack}
        startIcon={<ArrowBackIcon sx={{ fontSize: '20px' }} />}
        sx={{
          width: '100%',
          maxWidth: '250px',
          borderColor: '#667eea',
          color: '#667eea',
          fontFamily: 'Roboto-Bold !important',
          fontSize: '10pt !important',
          textTransform: 'uppercase !important',
          letterSpacing: '0.5px !important',
          borderRadius: '12px !important',
          px: 4,
          py: 1.5,
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            borderColor: '#667eea',
            borderWidth: '2px',
            background: 'rgba(102, 126, 234, 0.1)',
            transform: 'translateX(-4px)',
          },
          '&:disabled': {
            borderColor: '#e5e7eb',
            color: '#9ca3af',
          },
        }}
      >
        Previous
      </Button>

      {!isLastQuestion ? (
        <Button
          variant="contained"
          onClick={onNext}
          // disabled={!canGoNext || !canProceed}
          endIcon={<ArrowForwardIcon sx={{ fontSize: '20px' }} />}
          sx={{
            maxWidth: '250px',
            width: '100%',
            background:
              'linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important',
            // background:
            //   !canGoNext || !canProceed
            //     ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important'
            //     : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important',
            color: '#ffffff !important',
            fontFamily: 'Roboto-Bold !important',
            fontSize: '10pt !important',
            textTransform: 'uppercase !important',
            letterSpacing: '0.5px !important',
            borderRadius: '12px !important',
            px: 4,
            py: 1.5,
            border: 'none !important',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
            // boxShadow:
            //   !canGoNext || !canProceed
            //     ? '0 2px 8px rgba(156, 163, 175, 0.3)'
            //     : '0 4px 12px rgba(102, 126, 234, 0.3)',
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              background:
                'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%) !important',
              transform: !canGoNext || !canProceed ? 'none' : 'translateX(4px)',
              boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
            },
            // '&:hover': {
            //   background:
            //     !canGoNext || !canProceed
            //       ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important'
            //       : 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%) !important',
            //   transform: !canGoNext || !canProceed ? 'none' : 'translateX(4px)',
            //   boxShadow:
            //     !canGoNext || !canProceed
            //       ? '0 2px 8px rgba(156, 163, 175, 0.3)'
            //       : '0 6px 16px rgba(102, 126, 234, 0.4)',
            // },
            '&:disabled': {
              color: '#ffffff !important',
              cursor: 'not-allowed',
            },
          }}
        >
          Next
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={onSubmit}
          // disabled={!isFormValid}
          disabled={!isFormValid}
          startIcon={<SendIcon sx={{ fontSize: '20px' }} />}
          sx={{
            background: isFormValid
              ? 'linear-gradient(135deg, #10b981 0%, #059669 100%) !important'
              : 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important',
            color: '#ffffff !important',
            fontFamily: 'Roboto-Bold !important',
            fontSize: '10pt !important',
            textTransform: 'uppercase !important',
            letterSpacing: '0.5px !important',
            borderRadius: '12px !important',
            px: 5,
            py: 1.5,
            border: 'none !important',
            boxShadow: isFormValid
              ? '0 4px 12px rgba(16, 185, 129, 0.3)'
              : '0 2px 8px rgba(156, 163, 175, 0.3)',
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              background: isFormValid
                ? 'linear-gradient(135deg, #059669 0%, #047857 100%) !important'
                : 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important',
              transform: isFormValid ? 'scale(1.05)' : 'none',
              boxShadow: isFormValid
                ? '0 6px 20px rgba(16, 185, 129, 0.4)'
                : '0 2px 8px rgba(156, 163, 175, 0.3)',
            },
            '&:disabled': {
              color: '#ffffff !important',
              cursor: 'not-allowed',
            },
          }}
        >
          {submitButtonText}
        </Button>
      )}
    </Box>
  );
};
